
import React from 'react';

interface Review {
  id: string;
  name: string;
  rating: number;
  text: string;
  date: string;
}

const reviews: Review[] = [
  {
    id: '1',
    name: 'María González',
    rating: 5,
    text: 'Excelente servicio. Me han ayudado a ahorrar 28€ al mes en mi factura de luz. Muy profesionales y rápidos en la gestión.',
    date: 'Hace 2 semanas'
  },
  {
    id: '2',
    name: 'Carlos Ruiz',
    rating: 5,
    text: 'Totalmente recomendable. Revisaron mi factura y me cambiaron a una tarifa mucho mejor. Sin permanencia y todo gestionado por ellos.',
    date: 'Hace 1 mes'
  },
  {
    id: '3',
    name: 'Ana Martínez',
    rating: 5,
    text: 'Servicio rápido y honesto. Me dijeron que mi tarifa ya era buena y no me intentaron vender nada. Eso es profesionalidad.',
    date: 'Hace 3 semanas'
  },
  {
    id: '4',
    name: 'Javier López',
    rating: 5,
    text: 'He bajado 22€ al mes en luz y gas. El asesor me explicó todo muy bien y me gestionó el cambio sin complicaciones.',
    date: 'Hace 1 semana'
  },
  {
    id: '5',
    name: 'Laura Sánchez',
    rating: 5,
    text: 'Para mi empresa han conseguido un ahorro importante. Muy contentos con el servicio y la atención personalizada.',
    date: 'Hace 2 meses'
  },
  {
    id: '6',
    name: 'Pedro Fernández',
    rating: 5,
    text: 'Respuesta en menos de 24h como prometieron. Profesionales y transparentes. Ya he recomendado el servicio a varios amigos.',
    date: 'Hace 1 mes'
  }
];

interface GoogleReviewsProps {
  maxReviews?: number;
  compact?: boolean;
}

export const GoogleReviews: React.FC<GoogleReviewsProps> = ({ maxReviews = 3, compact = false }) => {
  const displayedReviews = reviews.slice(0, maxReviews);

  const renderStars = (rating: number) => {
    return (
      <div className="flex gap-0.5">
        {[...Array(5)].map((_, index) => (
          <i
            key={index}
            className={`ri-star-fill text-lg ${
              index < rating ? 'text-[#FBBC04]' : 'text-gray-300'
            }`}
          />
        ))}
      </div>
    );
  };

  return (
    <div className={`w-full ${compact ? 'py-8' : 'py-12'} bg-white`}>
      <div className="max-w-6xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-google-fill text-3xl" style={{ color: '#4285F4' }}></i>
            </div>
            <span className="text-sm font-medium text-gray-600">Reseñas de Google</span>
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-[#1F2937] mb-2">
            Lo que opinan nuestros clientes en Google
          </h3>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Antes de confiar tu factura, mira lo que dicen otros clientes.
          </p>
          <a
            href="https://share.google/IoDZpA29FjisUGSit"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-2 text-sm text-[#0A5FFF] hover:underline"
          >
            Valoración real basada en opiniones verificadas →
          </a>
        </div>

        {/* Reviews Grid */}
        <div className={`grid gap-6 ${compact ? 'md:grid-cols-2' : 'md:grid-cols-3'}`}>
          {displayedReviews.map((review) => (
            <div
              key={review.id}
              className="bg-[#F7F9FC] rounded-xl p-6 border border-gray-100 hover:shadow-lg transition-shadow duration-300"
            >
              {/* Rating */}
              <div className="mb-3">
                {renderStars(review.rating)}
              </div>

              {/* Review Text */}
              <p className="text-[#1F2937] text-sm leading-relaxed mb-4">
                "{review.text}"
              </p>

              {/* Author Info */}
              <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                <div>
                  <p className="font-semibold text-[#1F2937] text-sm">{review.name}</p>
                  <p className="text-xs text-gray-500">{review.date}</p>
                </div>
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-google-fill text-xl" style={{ color: '#4285F4' }}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Overall Rating Summary */}
        <div className="mt-8 text-center">
          <div className="inline-flex items-center gap-3 bg-[#F7F9FC] px-6 py-3 rounded-full border border-gray-100">
            <div className="flex items-center gap-1">
              <span className="text-2xl font-bold text-[#1F2937]">5.0</span>
              {renderStars(5)}
            </div>
            <span className="text-sm text-gray-600">Basado en más de 50 reseñas</span>
          </div>
        </div>
      </div>
    </div>
  );
};
